import { render, staticRenderFns } from "./BTabs.vue?vue&type=template&id=4bf6df3c&"
import script from "./BTabs.vue?vue&type=script&lang=ts&"
export * from "./BTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports